import { Service, signal } from '@angular/core';

/** Delay before the blocking overlay appears — avoids flicker on fast calls. */
const SHOW_DELAY_MS = 200;

/**
 * Counts pending HTTP requests (driven by the loader interceptor) and exposes
 * the `visible` signal consumed by the global blocking overlay.
 *
 * **Zasada: księgowość na zwykłych polach, sygnały wyłącznie do zapisu.**
 * `show()` woła interceptor, a interceptory jadą synchronicznie w momencie
 * `.subscribe()` — więc bywają uruchamiane ze środka `effect()`. Każdy ODCZYT
 * sygnału na tej ścieżce stałby się zależnością tego efektu, a `hide()` po
 * odpowiedzi wybudzałby go z powrotem: efekt strzela żądaniem raz jeszcze i
 * endpointy lecą w kółko. Zapis takiej zależności nie tworzy, więc przy tym
 * podziale błąd jest strukturalnie niemożliwy. Legacy trzyma to tak samo —
 * licznik jako zwykłe pole interceptora, serwis tylko z `isLoading$`.
 */
@Service()
export class LoaderService {
  private pendingCount = 0;
  private showTimer: ReturnType<typeof setTimeout> | null = null;

  private readonly _isLoading = signal(false);
  /** True while any tracked request is in flight. */
  readonly isLoading = this._isLoading.asReadonly();

  private readonly _visible = signal(false);
  /** True when the blocking overlay should be rendered. */
  readonly visible = this._visible.asReadonly();

  show(): void {
    this.pendingCount++;
    this._isLoading.set(true);
    // Odliczanie startuje tylko przy przejściu z zera — kolejne równoległe
    // żądania dołączają do trwającego okna, zamiast nakręcać własne timery.
    if (this.pendingCount === 1) {
      this.showTimer = setTimeout(() => {
        this.showTimer = null;
        // Timer dożywa tu tylko wtedy, gdy licznik ani razu nie spadł do zera —
        // `hide()` kasuje go po drodze. Czyli: coś na pewno wisi.
        this._visible.set(true);
      }, SHOW_DELAY_MS);
    }
  }

  hide(): void {
    // Nie ma czego chować — `hide()` bez pary `show()` to brak roboty.
    if (this.pendingCount === 0) {
      return;
    }
    this.pendingCount--;
    if (this.pendingCount > 0) {
      return;
    }
    this.clearTimer();
    this._isLoading.set(false);
    this._visible.set(false);
  }

  private clearTimer(): void {
    if (this.showTimer !== null) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }
  }
}
